import { ModuleType } from '../types/modules';

// TODO: rename all i18n widgets.* keys to use the back-end names for widgets not arbitrary names that we use now
// That will make this mapping obsolete.

const moduleTypeToTranslationKeyMap = {
  [ModuleType.ABOUT]: 'aboutMe',
  [ModuleType.ACTIVE_MEMBERS]: 'activeMembers',
  [ModuleType.ADMINS]: 'admins',
  [ModuleType.BADGES_ACTIVITY]: 'myBadges',
  [ModuleType.COMMENTS]: 'profileComments',
  [ModuleType.CUSTOM]: 'custombox',
  [ModuleType.DEVIOUSNESS]: 'deviousness',
  [ModuleType.DONATIONS]: 'donations',
  [ModuleType.EXHIBITIONIST]: 'exhibitionist',
  [ModuleType.FEATURED_DEVIATIONS]: 'featured',
  [ModuleType.FEATURED_DEVIATION]: 'featured_deviation',
  [ModuleType.FEATURED_JOURNALS]: 'featured_journals',
  [ModuleType.FEATURED_POSTS]: 'feed',
  [ModuleType.FEATURED_POST]: 'featured_post',
  [ModuleType.FEED]: 'feed',
  [ModuleType.GROUPS_ADMIN]: 'groups_admins',
  [ModuleType.GROUPS_MEMBER]: 'groups_member',
  [ModuleType.JOURNALS]: 'journal',
  [ModuleType.LATEST_DEVIATIONS]: 'latest_artworks',
  [ModuleType.MY_COMMENTS]: 'myComments',
  [ModuleType.STATS]: 'statistics',
  [ModuleType.WATCHERS]: 'watchers',
  [ModuleType.WATCHING]: 'watching',

  /* hidden modules */
  [ModuleType.COMMISSIONS]: '',
  [ModuleType.COVER_DEVIATION]: '',
  [ModuleType.DRAFTS]: '',
  [ModuleType.FEED_PINNED_DEVIATION]: '',
  [ModuleType.FOLDERS]: '',
  [ModuleType.FOLDER_DEVIATIONS]: '',
  [ModuleType.NEWEST_DEVIATIONS]: '',
  [ModuleType.POLLS]: '',
  [ModuleType.POSTS_FEED]: '',
  [ModuleType.PREMIUM_CONTENT]: '',
  [ModuleType.PREMIUM_FOLDERS]: '',
  [ModuleType.PRINTS]: '',
  [ModuleType.STATUSES]: '',
};
export const moduleTypeToTranslationKey = (moduleType: ModuleType) =>
  moduleTypeToTranslationKeyMap[moduleType] || 'unknown';
